import React from 'react';
import Typo from '../Typography/Typo';
import { EmptyStateButtonProp, TerritoryEmptyStateButton } from './TerritoryEmptyStateButton';
import { TerritoryEmptyStateContainerProps } from './TerritoryEmptyStateContainer';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';

type TTerritoryEmptyState = Partial<TerritoryEmptyStateContainerProps> & {
  isAuthenticated: boolean;
  canCreateInTerritory: boolean;
  tooltipDescription?: string;
  emptyStateType: EmptyStateButtonProp;
  territorySlug: string;
  territoryVersion: TerritoryVersionType;
};

export const TerritoryEmptyState = ({
  title,
  description,
  isAuthenticated,
  canCreateInTerritory,
  buttonTitle,
  buttonUrl,
  buttonAs,
  emptyStateType,
  territorySlug,
  buttonOnClick,
  territoryVersion,
}: TTerritoryEmptyState) => (
  <div className="flex py-36 px-5 flex-col gap-6 md:gap-10 items-center justify-center text-center border border-t2-neutral-grey03 rounded-xl">
    <div className="flex flex-col gap-3">
      <Typo variant="small-p" className="!text-xl text-t2-neutral-grey07">
        {title}
      </Typo>
      <Typo variant="small-p" className="!text-base text-t2-neutral-grey06">
        {description}
      </Typo>
    </div>
    <TerritoryEmptyStateButton
      title={buttonTitle}
      href={buttonUrl}
      as={buttonAs}
      onClick={buttonOnClick}
      disabled={!canCreateInTerritory}
      isAuthenticated={isAuthenticated}
      canCreateInTerritory={canCreateInTerritory}
      territorySlug={territorySlug}
      emptyStateType={emptyStateType}
      territoryVersion={territoryVersion}
    />
  </div>
);
